import {
  StyledCards,
  RingCard,
  InfoCard,
  TopCards,
  BubbleContent,
  BubbleWrapper,
} from "./styles/StyledCards";
import {
  SliderWrapper,
  SliderItem,
  SliderText,
  GradientOverlay,
} from "./styles/StyledLove";
import { useRef, useState, useEffect } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import videoFirst from '../../../../shared/assets/video/cards/main_video3_new.mp4';
import videoFirstEng from '../../../../shared/assets/video/cards/main_video3eng.mp4';
import videoSecond from '../../../../shared/assets/video/cards/main_video2_new.mp4';
import videoSecondEng from '../../../../shared/assets/video/cards/main_video2eng.mp4';
import videoThird from '../../../../shared/assets/video/cards/main_video1.mp4';
import videoThirdEng from '../../../../shared/assets/video/cards/main_video1eng.mp4';
import play from "../../../../shared/assets/img/love/love-play.svg";
import bubble from "../../../../shared/assets/img/cards/buble.png";
import firstPoster from "../../../../shared/assets/img/posters/main_video3_new.jpg";
import firstPosterEng from "../../../../shared/assets/img/posters/main_video3eng.jpg";
import secondPoster from "../../../../shared/assets/img/posters/main_video2_new.jpg";
import secondPosterEng from "../../../../shared/assets/img/posters/main_video2eng.jpg";
import thirdPoster from "../../../../shared/assets/img/posters/main_video1.jpg";
import thirdPosterEng from "../../../../shared/assets/img/posters/main_video1eng.jpg";
import { useTranslation } from 'react-i18next';
import {logoWhiteEng, logoWhiteRusH} from "../../../../shared/assets";

const Cards = () => {
  const { t, i18n } = useTranslation();
  const videoRefs = [useRef(null), useRef(null), useRef(null)];
  const [isMobile, setIsMobile] = useState(false);
  const [curentFirst, setcurentFirst] = useState(videoFirst);
  const [curentSecond, setcurentSecond] = useState(videoSecond);
  const [curentThird, setcurentThird] = useState(videoThird);
  const [curentFirstP, setcurentFirstP] = useState(firstPoster);
  const [curentSecondP, setcurentSecondP] = useState(secondPoster);
  const [curentThirdP, setcurentThirdP] = useState(thirdPoster);

  useEffect(() => {

    //if(i18n.language == 'ru') {
      setcurentFirst(videoFirst)
      setcurentSecond(videoSecond)
      setcurentThird(videoThird)
      setcurentFirstP(firstPoster)
      setcurentSecondP(secondPoster)
      setcurentThirdP(thirdPoster)
      
   //} else {
    //  setcurentFirst(videoFirstEng)
    //  setcurentSecond(videoSecondEng)
    //  setcurentThird(videoThirdEng)
    //  setcurentFirstP(firstPosterEng)
    //  setcurentSecondP(secondPosterEng)
    //  setcurentThirdP(thirdPosterEng)
    //}
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [i18n.language]);

  const handleMouseEnter = (index: any) => {
    if (videoRefs[index].current) {
      // @ts-ignore
      videoRefs[index].current.play();
    }
  };

  const handleMouseLeave = (index: any) => {
    if (videoRefs[index].current) {
      // @ts-ignore
      videoRefs[index].current.pause();
      // @ts-ignore
      videoRefs[index].current.currentTime = 0;
    }
  };

  const items = [
    { video: curentFirst, text: t('cards_item_1'), poster: curentFirstP },
    { video: curentSecond, text: t('cards_item_2'), poster: curentSecondP },
    { video: curentThird, text: t('cards_item_3'), poster: curentThirdP },
  ];

  // { video: t('main_video1'), text: t('cards_item_1'), poster: t('main_video1_poster') },
  // { video: t('main_video2'), text: t('cards_item_2'), poster: t('main_video2_poster')  },
  // { video: t('main_video3'), text: t('cards_item_3'), poster: t('main_video3_poster')  },

  return (
    <StyledCards>
      <TopCards>
        <RingCard>
          <div>
            <h3>{t('cards_item_title_1')}</h3>
            <p>
              {t('cards_item_desc_1')}
            </p>
          </div>
        </RingCard>
        <InfoCard>
          <h3>{t('cards_item_title_2')}</h3>
          <p>
            {t('cards_item_desc_2')} <br/> {t('cards_item_desc_2_1')}
          </p>
        </InfoCard>
        <BubbleWrapper>
          <img src={bubble} alt="" />
          <BubbleContent>
            <h3>{t('cards_item_title_3')}</h3>
            <p>
              {t('cards_item_desc_3')} <br/> {t('cards_item_desc_3_1')}
            </p>
          </BubbleContent>
        </BubbleWrapper>
      </TopCards>
      {isMobile ? (
        <Splide
          options={{
            arrows: false,
            pagination: true,
            drag: "free",
            gap: "1rem",
            breakpoints: {
              1200: {
                perPage: 2,
              },
              992: {
                perPage: 1,
              },
            },
          }}
        >
          {items.map((item, index) => (
            <SplideSlide key={item.video}>
              <SliderItem
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={() => handleMouseLeave(index)}
              >
                <video
                  ref={videoRefs[index]}
                  src={item.video}
                  loop
                  playsInline
                  poster={item.poster}
                ></video>
                <GradientOverlay className="gradient" />
                <img src={play} alt="" />
                {/*<SliderText>{item.text}</SliderText>*/}
              </SliderItem>
            </SplideSlide>
          ))}
        </Splide>
      ) : (
        <SliderWrapper>
          {items.map((item, index) => (
            <div key={item.video} style={{ textAlign: "center" }}>
              <SliderItem
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={() => handleMouseLeave(index)}
              >
                <video
                  ref={videoRefs[index]}
                  src={item.video}
                  muted
                  loop
                  playsInline
                  poster={item.poster}
                ></video>
                <GradientOverlay className="gradient" />
                <img src={play} alt="" />
                {/*<SliderText>{item.text}</SliderText>*/}
              </SliderItem>
            </div>
          ))}
        </SliderWrapper>
      )}
    </StyledCards>
  );
};

export default Cards;
